import { useEffect } from 'react'

import { setPaymentAlertError } from 'src/Redux/payment-process'
import { PaymentErrors } from 'src/Components/PaymentErrorsAlert'
import { useAppDispatch } from 'src/Hooks/redux'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { setCampaignBudget } from 'src/Redux/spotifyCampaignMatchingProcess'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

import { roundPriceValue } from './helpers'

export enum PaymentStatusEnum {
  SUCCESS = 'success',
  FAILURE = 'failure',
  ERROR = 'error',
}

export const useBackFromPaymentPageSpotify = (): void => {
  const dispatch = useAppDispatch()
  const { setStartDate } = useSpotifyCampaignStatus()

  const { search } = useCustomSearchParams()

  const urlStartDate = search.get('startDate')
  const errorType = search.get('errorType')
  const paymentStatus = search.get('paymentStatus')
  const urlBudget = search.get('budget')
  const baToken = search.get('ba_token')

  const isBackFromPaymentPageWithoutError =
    paymentStatus === PaymentStatusEnum.FAILURE && urlStartDate

  const isBackFromPaymentPageWithError =
    paymentStatus === PaymentStatusEnum.ERROR && !baToken && urlStartDate

  useEffect(() => {
    if (isBackFromPaymentPageWithoutError || isBackFromPaymentPageWithError) {
      isBackFromPaymentPageWithError &&
        dispatch(
          setPaymentAlertError(
            (errorType as PaymentErrors) || PaymentErrors.DEFAULT,
          ),
        )
      const roundedValue = roundPriceValue(urlBudget || 0)

      setStartDate(urlStartDate)
      dispatch(setCampaignBudget(roundedValue))
    }
  }, [
    baToken,
    dispatch,
    errorType,
    isBackFromPaymentPageWithError,
    isBackFromPaymentPageWithoutError,
    paymentStatus,
    setStartDate,
    urlBudget,
    urlStartDate,
  ])
}
